import * as React from 'react';
import styles from './index.less';
import Poster from './Poster';
import FNavTabs from '@/components/FNavTabs';
import { FUtil } from '@freelog/tools-lib';
import Resources from './market';
import Examples from './examples';
import { useLocation } from 'umi';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import { ConnectState, DiscoverPageModelState } from '@/models/connect';
import { OnChange_ShowPage_Action } from '@/models/discoverPage';
import FPageFooter from '@/components/FPageFooter';

interface DiscoverProps {
  dispatch: Dispatch;
  discoverPage: DiscoverPageModelState;
}

function Discover({ dispatch, discoverPage }: DiscoverProps) {
  const location = useLocation();
  const pathname = location.pathname;

  React.useEffect(() => {
    if (pathname?.startsWith(FUtil.LinkTo.market())) {
      dispatch<OnChange_ShowPage_Action>({
        type: 'discoverPage/onChange_ShowPage',
        payload: {
          value: 'market',
        },
      });
    }
    if (pathname?.startsWith(FUtil.LinkTo.exampleNodes())) {
      dispatch<OnChange_ShowPage_Action>({
        type: 'discoverPage/onChange_ShowPage',
        payload: {
          value: 'example',
        },
      });
    }
  }, [pathname]);

  return (<div>
    <div className={styles.top}>
      <Poster />
      <div style={{ height: 10 }} />
      <FNavTabs
        variant="discover"
        options={[
          {
            value: 'market',
            label: '资源市场',
            href: FUtil.LinkTo.market(),
          },
          {
            value: 'example',
            label: '示例节点',
            href: FUtil.LinkTo.exampleNodes(),
          },
        ]}
        activated={discoverPage.showPage}
      />
    </div>
    <div className={styles.content}>
      <div className={styles.contentInner}>
        {discoverPage.showPage === 'market' && <Resources />}
        {discoverPage.showPage === 'example' && <Examples />}
      </div>
    </div>
    {/*<FFooter />*/}
    <FPageFooter />
  </div>);
}

export default connect(({ discoverPage }: ConnectState) => ({
  discoverPage,
}))(Discover);
